import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { NOTES_QUERY_KEY } from "./useNotes";

export type DeleteNoteVariables = {
  noteId: string;
};

export function useDeleteNote() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteNoteVariables>({
    mutationFn: async ({ noteId }) => {
      const { error } = await client.DELETE("/api/notes/{note_id}", {
        params: { path: { note_id: noteId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to delete note ${noteId}`);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTES_QUERY_KEY });
    },
  });
}
